<template>
  <div class="game-trade-platform">
    <!-- 头部导航 -->
    <header class="header">
      <div class="container">
        <div class="header-content" style="cursor: pointer;">
          <div class="logo">
            <img 
              src="https://p9-flow-imagex-sign.byteimg.com/tos-cn-i-a9rns2rl98/rc/pc/super_tool/7ef9a6293c17402996489803267fec2e~tplv-a9rns2rl98-image.image?rcl=202512091413164609D08F7D1B187AB6E8&rk3s=8e244e95&rrcfp=f06b921b&x-expires=1767852827&x-signature=yQIgp6wQmOdm2JlQnpoJ0nKqhd8%3D" 
              alt=" 萌梦谷LOGO"
              loading="lazy"
            >
            声亿智能
          </div>
          <div class="search-box">
            <i class="fas fa-search"></i>
            <input 
              type="text" 
              class="search-input" 
              placeholder="搜索游戏装备、道具..." 
              v-model="queryParams.item_name"
              @input="handleSearchInput"
            >
          </div>
          <div class="header-actions">
            <button class="action-btn" aria-label="发布" @click="fabu">
              <i class="fas fa-upload"></i>
              <span>发布</span>
            </button>
           
            <!--<button class="action-btn" aria-label="收藏">
              <i class="fas fa-heart"></i>
              <span>收藏</span>
            </button>
            <button class="action-btn" aria-label="购物车">
              <i class="fas fa-shopping-cart"></i>
              <span>购物车</span>
            </button>-->
            <button class="action-btn btn-primary">{{ route.query.a }}</button>
          </div>
        </div>
      </div>
    </header>

    <!-- 主要内容区 -->
    <div class="container">
      <div class="main-content">
        <!-- 商品列表区 -->
        <section class="product-section">
          <div class="section-header">
            <h2 class="section-title">最新商品</h2>
            <div class="view-options">
              <button class="view-option active" @click="setViewType('all')">全部</button>
              <button class="view-option" @click="setViewType('weapon')">装备</button>
              <button class="view-option" @click="setViewType('armor')">消耗</button>
              <button class="view-option" @click="setViewType('ornament')">装饰</button>
              <button class="view-option" @click="setViewType('other')">其他</button>
              <button class="view-option" @click="setViewType('cash')">现金</button>
              <button class="view-option" @click="setViewType('shizhuang')">时装</button>
              <button class="view-option" @click="setViewType('coin')">游戏币</button>
            </div>
          </div>
          <div class="product-grid">
            <!--processedProducts--> 
            <div 
              class="product-card" 
              v-for="product in products"
              :key="product.id"
              @click="handleProductClick(product.id)"
            >
            <el-tooltip placement="right">
            
              <div class="product-image" @mouseenter.native="mouseenterF" @mouseleave.native="mouseleaveF(product.id)">
                
                <img 
                  :src="`http://ccmaple.cc/mxditem/${product.item_id}.png`" 
                  :alt="product.item_name"
                  loading="lazy"
                >
                
              </div>
              </el-tooltip>
              <div class="product-info">
                <h3 class="product-name">{{ product.item_name }}</h3>
                <p class="product-description">{{ product.mall_dec }}</p>
                <div class="parent-div">
                  <div class="product-price" style="background-color: forestgreen;">¥{{ product.price }}</div>
                  <div class="product-num">数量:1000</div>
                </div>
                <div class="product-seller">
                  <div class="seller-name">
                    <i class="fas fa-user"></i>
                    <span>{{ product.cname }}</span>
                    <!--<span class="seller-status" :class="'status-' + product.sellerStatus">
                      {{ product.sellerStatus === 'online' ? '在线' : '离线' }}
                    </span>-->
                  </div>
                  <div class="product-time"><i class="fas fa-eye"></i>{{ product.views }}</div>
                </div>
                 <div class="product-actions">
                
                  <!--<div class="action-button btn-buy" style="text-align: center;" @click="addVeiw(product.id)"><i class="fas fa-commenting"></i><a target="_blank" :href="qq_group" style="color: white;">联系客服</a>-->
                  <button class="action-button btn-buy" @click.stop="handleContactSeller(product.id)">我想买</button>
                  <!--<button class="action-button btn-contact" @click.stop="handleContactSeller(product.id)">查看详情</button>-->
                </div>
              </div>
            </div>
          </div>
          
        </section>
        

      </div>
    </div>
    <div class="pagination">
          <pagination
      v-show="total>0"
      :total="total"
      pageSizes="8"
      v-model="queryParams.pageNum"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
      <!--<span style="margin-right: 10px;color: gray;">第 {{ queryParams.pageNum }} 页<span style="color: gray;"> | 共1页 | </span></span><span style="color: gray;">共 {{ total }} 条</span>
      <button class="action-button btn-buy" @click.stop="prePage" style="margin-right: 30px;">上一页</button>
      <button class="action-button btn-contact" @click="nextPage">下一页</button>-->
    </div>
    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-column">
            <h3>关于我们</h3>
            <ul class="footer-links">
              <li><a href="#">平台介绍</a></li>
             
            </ul>
          </div>
          <div class="footer-column">
            <h3>交易指南</h3>
            <ul class="footer-links">
              <li><a href="#">新手指南</a></li>
              <li><a href="#">交易流程</a></li>
              
            </ul>
          </div>
          <div class="footer-column">
            <h3>服务支持</h3>
            <ul class="footer-links">
              <li><a href="#">售后服务</a></li>
              <li><a href="#">安全提示</a></li>
              <li><a href="#">常见问题</a></li>
            </ul>
          </div>
          <div class="footer-column">
            <h3>商务合作</h3>
            <ul class="footer-links">
           
              <li><a href="#">广告投放</a></li>
              <li><a href="#">媒体合作</a></li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2025  萌梦谷游戏交易平台 版权所有</p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import {Form, Message} from 'element-ui';
import { loadStripe } from '@stripe/stripe-js';
  export default {
    data() {
      return {
        stripe: null,
        cardElement: null,
        isMobile: false,
        ruleForm: {
          serviceId:'',
          service_id:'',
          usdt:2,
          remark:'',
          game_account_name:'',
          user_type:0,
          amt:10
        },
        qjf:{},
        commission:0.003,
        accounts:[],
        paymentType:false,
        payBtn:false,
        tip:'請掃碼支付',
        tipFlag:true,
        options:[],
        u_scale : 1,
        orderNo:'',
        server_name:'',
        alipay:'',
        out_pay_url:'',
        rules: {
          amt: [
            { required: true, message: '請填寫金額', trigger: 'blur' },
            
          ],
          game_account_name: [
            { required: true, message: '請輸入遊戲賬號', trigger: 'blur' },
          ],
        }
      };
    },
    async created(){
  
        this.isMobile = window.innerWidth < 768;
        console.log(this.isMobile);
        let self = this;
        var url = window.location.href ;             //獲取當前url
        var cs={};
        if(url.indexOf('#') > -1 && url.indexOf('?') > -1 &&  url.indexOf('&') > -1){ 
            var dz_url = url.split('#')[0];                //獲取#/之前的字符串
            var csstr = dz_url.split('?')[1];                //獲取?之後的參數字符串
            var cs_arr = csstr.split('&');                    //參數字符串分割為數組
       
            for(var i=0;i<cs_arr.length;i++){         //遍歷數組，拿到json對象
              if(cs_arr[i]){
                if(cs_arr[i].split('=')){
                  cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1] 
                }
              }
            }
        }
    
        if(cs.service_id){ 
           //這樣就拿到了參數中的數據
            self.ruleForm.serviceId = cs.service_id;   
     
        }else{
            self.ruleForm.serviceId = '44f714b60a064f738b1dd56a9c16ad4c'
        }
        self.ruleForm.service_id = self.ruleForm.serviceId;    
        this.getParam();
        this.queryCommission();
        this.queryJF();
        await this.st();
    },
    methods: {
      async st(){
           // 1. 加载 Stripe.js 和 Elements
          this.stripe = await loadStripe('pk_test_51SgOGc8cwYPKzEDf0TU5KsFngzTwbyC5JKt0mN2jCgSuX5R9DFdduTLvslTLMMdTOCNsl9PXgVqNv8kYhLXapLdo00xnu234rl'); // 替换为你的公钥
          const elements = this.stripe.elements();

          // 2. 创建卡片元素
          this.cardElement = elements.create('card', {
            style: {
              base: {
                fontSize: '16px',
                color: '#32325d',
              },
            },
          });

          // 3. 将卡片元素挂载到 DOM
          this.cardElement.mount('#card-element');
      },
      paymentBtn(){
        window.open(this.out_pay_url, "_blank");

       // window.location.href= "http://app.sxzbd.com/pay/tbNg";
      },
      queryCommission(){
        let self = this;
        self.postRequest('/usdt/commission',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.commission = resp.data;
        })
      },
      queryAccount(){
        let self = this;
        self.postRequest('/game/characters_list',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.accounts = resp.data;
        })
      },
      queryJF(){
        let self = this;
        this.ruleForm.price = self.ruleForm.amt;
        self.postRequest('/order/integral_price',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.qjf = resp.data;
        })
      },
      submitForm(formName) {
          let self = this;
          self.payBtn = true;
          self.$refs[formName].validate((valid) => {
          if (valid) {
            self.postRequest('/stripe/pay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                
                 console.log(resp.data);
                self.goStripePay(resp.data);

            })


          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
      },
      async goStripePay(pay_secret){ 
      
        const { paymentIntent, error } = await this.stripe.confirmCardPayment(
              pay_secret, // 从后端获取
              {
                payment_method: {
                  card: this.cardElement,
                  billing_details: {
                    name: 'John Doe', // 示例，实际应来自用户输入
                  },
                },
              }
            );

            if (error) {
              console.error(error);
              // 处理错误
            } else {
              // 支付成功，跳转到成功页面或更新UI
              console.log('Payment successful:', paymentIntent);
              // 通常在这里调用后端接口，通知服务器支付成功
              this.postRequest('/stripe/webhook',paymentIntent).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 console.log(resp.data);
            })
            }

      },
      getParam(){
        let self = this;
  
        console.log("this.ruleForm.service_id:"+self.ruleForm.service_id);

        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                self.out_pay_url = resp.data.out_pay_url;
                self.u_scale = resp.data.u_scale;
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
            })

       

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      
  
      handleClose(done) {
        this.$confirm('確認關閉？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    },
  }
</script>
<style scoped>

    .content{
     
        margin-top: 50px;
        width: 100%;
          /* 水平垂直都居中 */
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
   
      
    }
    .form-class{
        padding-top: 50px;
        padding-left: 100px;
        padding-right: 100px;
        width: 100%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
     
    }
    .moble-form-class{
      padding-top: 30px;
       width: 100%;
        height: 500px;
        max-height: 800px;
        background-color: rgb(55, 155, 153);
        border-radius: 20px;
    }

</style>



<style scoped>
/* 变量定义 */

/* 基础样式 */
.game-trade-platform {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
  color: #333333;
  line-height: 1.6;
  min-height: 100vh;
}
.el-rate-st{
  margin: 0 auto; /* 容器居中 */
  text-align: center;
  width: 180px; /* 自定义每行宽度，比如300px */
  /* 可选：添加内边距，避免内容贴边 */
  padding: 10px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* 头部样式 */
.header {
  background-color: #ffffff;
  border-bottom: 1px solid  #e0e0e0;
  padding: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: #667eea;
  gap: 0.5rem;
}

.logo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.search-box {
  flex: 1;
  max-width: 500px;
  position: relative;
}
/* 穿透修改 el-rate 核心样式 */
:deep(.el-rate) {
  /* 核心：允许flex换行 */
  flex-wrap: wrap;
  /* 可选：调整行间距 */
  row-gap: 8px;
}

/* 调整星星图标间距，适配换行 */
:deep(.el-rate__icon) {
  margin-right: 4px; /* 缩小星星间距，每行能放更多 */
  /* 可选：缩小星星尺寸，适配换行布局 */
  font-size: 14px !important;
}

/* 调整分数文本位置（换行后和星星对齐） */
:deep(.el-rate__text) {
  /* 让分数文本独占一行，避免和星星挤在一起 */
  width: 100%;
  margin-top: 8px;
  color: #ff6700;
}
.search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  background-color: #ffffff;
  border: 1px solid  #e0e0e0;
  border-radius: 8px;
  color: #333333;
  font-size: 0.875rem;
  transition: border-color 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.search-box i {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #999999;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.action-btn {
  background: none;
  border: none;
  color: #666666;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  
  gap: 0.25rem;
}

.action-btn:hover {
  background-color: rgba(102, 126, 234, 0.1);
  color: #667eea;
  
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  background-color: #667eea;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

/* 导航栏样式 */
.navigation {
  background-color: #ffffff;
  border-bottom: 1px solid  #e0e0e0;
  padding: 0.5rem 0;
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: #666666;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.nav-link:hover, .nav-link.active {
  color: #667eea;
}

.nav-link.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 500;
}

.nav-link i {
  font-size: 1.25rem;
}

.filter-options {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.filter-btn {
  background: none;
  border: 1px solid  #e0e0e0;
  color: #666666;
  cursor: pointer;
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.filter-btn:hover, .filter-btn.active {
  border-color: #667eea;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

/* 横幅样式 */
.banner {
  margin: 1rem 0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.banner img {
  width: 100%;
  height: auto;
  display: block;
}

.banner-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 2rem;
  color: white;
}

.banner-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.banner-description {
  font-size: 0.875rem;
  opacity: 0.9;
  max-width: 600px;
}

/* 主要内容区 */
.main-content {
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}

/* 商品列表区 */
.product-section {
  width: 1200px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #333333;
}

.view-options {
  display: flex;
  gap: 0.5rem;
}

.view-option {
  background: none;
  border: 1px solid  #e0e0e0;
  color: #666666;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.view-option.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  background-color: #667eea;
  color: white;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.product-card {
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.product-image {
  position: relative;
  border: 1px solid #fcfbfb; /* 方便查看效果 */
  background-color: #fcfbfb;
  text-align: center; /* 核心：水平居中 */
  
  height: 150px;
  overflow: hidden;
}

.product-image img {
  
  width: 150px;
  height: 150px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.05);
}

.product-rarity {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.rarity-common {
  background-color: #9e9e9e;
  color: white;
}

.rarity-uncommon {
  background-color: #4caf50;
  color: white;
}

.rarity-rare {
  background-color: #2196f3;
  color: white;
}

.rarity-epic {
  background-color: #9c27b0;
  color: white;
}

.rarity-legendary {
  background-color: #ff9800;
  color: white;
}

.product-info {
  padding: 1rem;
}

.product-name {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #333333;
}

.product-description {
  font-size: 0.875rem;
  color: #666666;
  margin-bottom: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 40px;
}
.product-num{
    font-size: 0.7rem;
  font-weight: 500;
  background: linear-gradient(135deg, #a2a9c7 0%, #bbabcc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.5rem;
}
.product-price {
  font-size: 1.25rem;
  font-weight: 500;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.5rem;
}

.product-seller {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: #999999;
  margin-bottom: 1rem;
}

.seller-name {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.seller-status {
  padding: 0.125rem 0.375rem;
  border-radius: 4px;
  font-size: 0.625rem;
}

.status-online {
  background-color: rgba(76, 175, 80, 0.2);
  color: #4caf50;
}

.status-offline {
  background-color: rgba(158, 158, 158, 0.2);
  color: #9e9e9e;
}

.product-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.action-button {
  flex: 1;
  padding: 0.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-buy {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-buy:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-contact {
  background-color: transparent;
  border: 1px solid #667eea;
  
  color: #667eea;
}

.btn-contact:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

/* 侧边栏样式 */
.sidebar {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.parent-div {
  width: 100%;
  /* Flex 核心：让子元素同行显示 */
  display: flex;
  /* 可选：子元素之间的间距（替代margin） */
  justify-content: space-between;
}
.sidebar-section {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.sidebar-title {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #333333;
}

.announcement-list {
  list-style: none;
}

.announcement-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid  #e0e0e0;
}

.announcement-item:last-child {
  border-bottom: none;
}

.announcement-title {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: #333333;
}

.announcement-date {
  font-size: 0.75rem;
  color: #999999;
}

.announcement-link {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: none;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  display: inline-block;
}

.announcement-link:hover {
  text-decoration: underline;
}

.quick-links {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.quick-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 8px;
  color: #666666;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid  #e0e0e0;
}

.quick-link:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: transparent;
}

.quick-link i {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.quick-link span {
  font-size: 0.75rem;
}

.contact-info {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid  #e0e0e0;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-item i {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.pagination{

  border-radius: 3px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;

}
.contact-item a {
  color: #666666;
  text-decoration: none;
}

.contact-item a:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* 页脚样式 */
.footer {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-top: 1px solid  #e0e0e0;
  padding: 2rem 0;
  margin-top: 2rem;
  box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.05);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.footer-column h3 {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: #666666;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #667eea;
}

.footer-bottom {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid  #e0e0e0;
  text-align: center;
  color: #999999;
  font-size: 0.75rem;
}

/* 响应式样式 */
@media (max-width: 1024px) {
  .main-content {
    grid-template-columns: 1fr;
  }

  .footer-content {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: stretch;
  }

  .search-box {
    max-width: 100%;
  }

  .nav-content {
    flex-direction: column;
    align-items: stretch;
  }

  .nav-menu {
    justify-content: center;
  }

  .filter-options {
    justify-content: center;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
}

@media (max-width: 480px) {
  .product-grid {
    grid-template-columns: 1fr;
  }

  .product-actions {
    flex-direction: column;
  }

  .footer-content {
    grid-template-columns: 1fr;
  }

  .banner-content {
    padding: 1rem;
  }

  .banner-title {
    font-size: 1.25rem;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.game-trade-platform {
  animation: fadeIn 0.5s ease-in-out;
}

.product-card {
  animation: fadeIn 0.3s ease-in-out;
  animation-fill-mode: both;
}

.product-card:nth-child(1) { animation-delay: 0.05s; }
.product-card:nth-child(2) { animation-delay: 0.1s; }
.product-card:nth-child(3) { animation-delay: 0.15s; }
.product-card:nth-child(4) { animation-delay: 0.2s; }
.product-card:nth-child(5) { animation-delay: 0.25s; }
.product-card:nth-child(6) { animation-delay: 0.3s; }
</style>